import { Box } from "@bca/ui-library";
import React, { useContext } from "react";
import { ThemeContext } from "styled-components";

import StyledIcon from "../Interfaces/StyledIcon";

const ArrowDownSVG: React.FunctionComponent<StyledIcon> = ({
  fill = "primary-light-blue",
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const hexColor = theme.colors[fill] || fill;
  return (
    <Box {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.14289 7.92071L3.94763 7.1388C4.13811 6.95373 4.44695 6.95373 4.63746 7.1388L12 14.275L19.3625 7.1388C19.553 6.95373 19.8618 6.95373 20.0524 7.1388L20.8571 7.92071C21.0476 8.10577 21.0476 8.40583 20.8571 8.59093L12.3449 16.8612C12.1545 17.0463 11.8456 17.0463 11.6551 16.8612L3.14289 8.59093C2.95237 8.40583 2.95237 8.10577 3.14289 7.92071Z"
          fill={hexColor}
          stroke={hexColor}
        />
      </svg>
    </Box>
  );
};

export default ArrowDownSVG;
